// Check if the app is in a standalone mode (PWA).
export default function isStandalone() {
  return ('standalone' in window.navigator) && (window.navigator.standalone);
}
